import { connect } from "react-redux"
import ProductList from "../../components/shop/product-list"

const isSortable = () => window.App.current_user.role === "admin" || window.App.current_user.role === "manager"

const commonStateToProps = state => ({
  ...state.currentShop.productList,
  items: state.entities.products
})

const commonDispatchToProps = dispatch => ({
  onClickNewProduct: () => dispatch({type: "SHOP.NEW_PRODUCT"}),
  onClickProduct: id => dispatch({type: "SHOP_CART_ADD_ITEM", payload: {id}}),
  onClickUncategorizedProduct: (amount) => dispatch({type: "SHOP_CART_ADD_UNCATEGORIZED_PRODUCT", payload: {amount}}),
  onClickReservationProduct: () => dispatch({type: "SHOP_RESERVATION_ADD"}),
  onDeleteProduct: id => dispatch({type: "SHOP_PRODUCT_REMOVE", payload: {id}}),
  onSortProducts: (ids, groupId) => dispatch({type: "SHOP_PRODUCTS_SORT", payload: {ids, groupId}})
})

const shopStateToProps = state =>({
  ...commonStateToProps(state),
  filter: state.currentShop.productFilter.value,
  currentShop: state.currentShop.entity,
  canAdd: true
})

const inventoryStateToProps = state =>({
  ...commonStateToProps(state),
  showQuantityInStock: true,
  canDelete: true,
  isSortable: isSortable()
})

const inventoryDispatchToProps = dispatch => ({
  ...commonDispatchToProps(dispatch),
  onClickProduct: id => dispatch({type: "SHOP.EDIT_PRODUCT", payload: {id}}),
})

const ShopProductList = connect(shopStateToProps, commonDispatchToProps)(ProductList)

const InventoryProductList = connect(inventoryStateToProps, inventoryDispatchToProps)(ProductList)

const ReservationProductList = connect(commonStateToProps, commonDispatchToProps)(ProductList)

export {ShopProductList, InventoryProductList, ReservationProductList}
